var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollapse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1.8vw",
    height: "1.7vw",
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 34,
    rx: 5,
    fill: "#50C878"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7776 11.9262L19.8333 9.98197V15.1666H25.018L23.0737 13.2224L25.9814 10.3147L24.6852 9.01855L21.7776 11.9262ZM11.3147 9.01855L10.0186 10.3147L12.9262 13.2224L10.982 15.1666H16.1666V9.98197L14.2224 11.9262L11.3147 9.01855ZM25.018 18.8333H19.8333V24.018L21.7776 22.0737L24.6852 24.9814L25.9814 23.6852L23.0737 20.7776L25.018 18.8333ZM12.9262 20.7776L10.0186 23.6852L11.3147 24.9814L14.2224 22.0737L16.1666 24.018V18.8333H10.982L12.9262 20.7776Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/collapse.1eb3220a8b2624cba0795b5b62a5c05b.svg";
export { ForwardRef as ReactComponent };